/**
 * This is a React component that displays a quick view of a product with options to select variations,
 * delete variations, and repeat variations.
 * @returns The component `ProductQuickViewComponent` is being returned.
 */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ReactLoading from "react-loading";

import DeleteVariation from "./VariationModal/DeleteVariation";
import RepeatVariation from "./VariationModal/RepeatVariation";
import SelectVariation from "./VariationModal/SelectVariation";
import { LoaderColor } from "../../utils/productUtils/ProductUtils";
import { resetSelectedProduct } from "../../State/actions/productActions";

const ProductQuickViewComponent = ({
  id,
  relatedDiv,
  setRelatedDiv,
  loadingOnProductQuickPage,
  showBestQuickView,
  showProductQuickViewModal,
  triggerQuickViewModal,
  showTrendingQuickView,
  setloadingOnProductQuickPage,
}) => {
  const dispatch = useDispatch();
  const { cartItems, selectedProduct } = useSelector((state) => state);
  const [productVarient, setProductVarient] = useState([]);
  const [varientIndex, setVarientIndex] = useState(0);
  const [productDetail, setProductDetail] = useState([]);

  /* The function checks if all product attributes have been selected. */
  const [counter, setCounter] = useState(0);
  const [filteredCartForVariant, setFilteredCartForVariant] = useState([]);

  /* This code filters cart items by product ID, updates state variables filteredCartForVariant and counter, 
  and uses useEffect to update counter when cart or product changes. */
  useEffect(() => {
    if (!selectedProduct.productVarient[varientIndex]) {
      return;
    }
    const newCartItems = cartItems.filter(
      (cartItem) =>
        cartItem.productid ===
        selectedProduct.productVarient[varientIndex].productid
    );

    setFilteredCartForVariant(newCartItems);
    const qty = newCartItems.reduce(
      (total, cartItem) => total + cartItem.quantity,
      0
    );

    setCounter(qty);
  }, [cartItems, selectedProduct]);

  useEffect(() => {
    setVarientIndex(0);
  }, [showProductQuickViewModal, showBestQuickView, showTrendingQuickView]);

  useEffect(() => {
    if (counter === 0) {
      triggerQuickViewModal("close");
    }
  }, [counter]);
  const handleCloseQuickView = () => {
    setProductDetail([]);
    setProductVarient([]);
    setloadingOnProductQuickPage(true);
    triggerQuickViewModal("close");
    dispatch(resetSelectedProduct());
  };
  return (
    <>
      {(showProductQuickViewModal ||
        showBestQuickView ||
        showTrendingQuickView) && (
        <>
          <div
            id="cd-shadow-layer"
            style={{
              display: "block",
            }}
            onClick={handleCloseQuickView}
          ></div>

          <div className="mainWrapper removeVariationWrapper active quickview_container">
            <div className="WishlistmainBackground clearfix quickview_background">
              <div className="column small-centered WishlistModel">
                <div className="productCard_block px-0 m-0" style={{padding:"0px"}}>
                  {
                    /* `loadingOnProductQuickPage` is a boolean state variable that is used to determine
                  whether to display a loading spinner or not.  */
                    loadingOnProductQuickPage &&
                    selectedProduct.productdetalils.length <= 0 &&
                    productDetail.length <= 0 ? (
                      <div className="row">
                        <div className="col-12">
                          <div className="loader mb-5">
                            <ReactLoading
                              type="spinningBubbles"
                              color={LoaderColor}
                              height={100}
                              width={50}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <SelectVariation
                          varientIndex={varientIndex}
                          setVarientIndex={setVarientIndex}
                          productVarient={productVarient}
                          setProductVarient={setProductVarient}
                          relatedDiv={relatedDiv}
                          triggerQuickViewModal={triggerQuickViewModal}
                          showProductQuickViewModal={showProductQuickViewModal}
                          showTrendingQuickView={showTrendingQuickView}
                          showBestQuickView={showBestQuickView}
                          setloadingOnProductQuickPage={
                            setloadingOnProductQuickPage
                          }
                          productDetail={productDetail}
                          setProductDetail={setProductDetail}
                        />
                        <DeleteVariation
                          relatedDiv={relatedDiv}
                          filteredCartForVariant={filteredCartForVariant}
                          triggerQuickViewModal={triggerQuickViewModal}
                          setRelatedDiv={setRelatedDiv}
                          id={id}
                        />

                        <RepeatVariation
                          id={id}
                          productVarient={productVarient}
                          varientIndex={varientIndex}
                          relatedDiv={relatedDiv}
                          setRelatedDiv={setRelatedDiv}
                          triggerQuickViewModal={triggerQuickViewModal}
                        />
                      </>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default ProductQuickViewComponent;
